import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';
import I18n from 'PMT/i18n/I18n';

import {
  Product,
  UpsellingCategory,
  RestaurantMenu,
  ProductPrices
} from 'PMT/entities/menu';

import {
  Utils
} from 'PMT/utils';

import { Modal } from 'react-bootstrap';
import { TextInputLocalized } from 'PMT/components/form';

import Constants from '../../../constants/Constants'

/**
 *
 */
export default class EditUpsellingCategoryModal extends Component {

  static CUSTOM_DESCRIPTION_MAX_LENGTH = 50;

  static propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,

    upsellingCategory: PropTypes.instanceOf(UpsellingCategory),

    // params: Product
    onUpdate: PropTypes.func.isRequired,
  };

  static defaultProps = {
    upsellingCategory: null
  };

  state = {
    upsellingCategory: _.isNull(this.props.upsellingCategory) ? new UpsellingCategory() : this.props.upsellingCategory.copy(),

    validationErrors: [] // contains the upsellingCategory.getValidationErrors() when click on isValid
  };

  get upsellingCategory():Product {
    return this.state.upsellingCategory;
  }

  isPut(): boolean {
    return !_.isNull(this.props.upsellingCategory);
  }

  onHide = () => {
    this.props.onHide();
  };

  onClose = () => {
    this.props.onHide();
  };

  onDelete = (event) => {
    event.preventDefault();

    this.props.onDelete(this.props.upsellingCategory);
  };

  onChange = (upsellingCategory: UpsellingCategory) => {
    this.setState({
      upsellingCategory
    });
  };

  onNameChange = (newValue: string) => {
    const upsellingCategory:UpsellingCategory = this.upsellingCategory;
    upsellingCategory.localizedNames = newValue;
    this.onChange(upsellingCategory);
  };

  onDescriptionChange = (newValue: string) => {
    const upsellingCategory:Product = this.upsellingCategory;
    upsellingCategory.localizedDescriptions = newValue;
    this.onChange(upsellingCategory);
  };

  onValidate = (event) => {
    event.preventDefault();

    const upsellingCategory:UpsellingCategory = this.upsellingCategory;

    /**
     * We need to create a unique pos id if  we create a new product
     */
    if (!this.isPut()) {
      upsellingCategory.id = Utils.generateUID();

      /**
       * Activated by default.
       * @type {boolean}
       */
  //    upsellingCategory.activated = true;

    } else {
      upsellingCategory.id = this.props.upsellingCategory.id;
    }

    if (upsellingCategory.isValid()) {
      if (this.isPut()) {
        this.props.onUpdate(upsellingCategory);
        this.onClose();
      } else {
        // TODO: push to the API
      }
    } else {
      const validationErrors = upsellingCategory.getValidationErrors();
      console.info('category invalid', validationErrors);
      this.setState({
        validationErrors
      });
    }
  };

  //
  get title(): string {
    if (_.isNull(this.props.upsellingCategory)) {
      return I18n.tr('components.menu.edit_upselling_category.new');
    }
    return I18n.tr('components.menu.edit_upselling_category.edit');
  }

  // -- renderers

  renderBody() {
    return (
      <form
        className="form form-horizontal product_category_create__form"
        role="form"
        noValidate
      >
        <div className="form-group">
          <div className="required col-xs-4 control-label">
            <label>
              {I18n.tr('components.menu.edit_upselling_category.name')}
            </label>
          </div>
          <div className="col-xs-6">
            <TextInputLocalized
              locales={Constants.localesForTranslation}
              values={this.upsellingCategory.localizedNames}
              isRequired
              className="form-control"
              placeholder={I18n.tr('components.menu.edit_upselling_category.name_placeholder')}
              onChange={this.onNameChange}
            />
          </div>
          <div className="form_error col-xs-6 col-xs-offset-4">
            {this.state.validationErrors.name}
          </div>
        </div>

        <div className="form-group">
          <div className="col-xs-4 control-label">
            <label>{I18n.tr('components.menu.edit_upselling_category.description')}</label>
          </div>
          <div className="col-xs-6">
            <TextInputLocalized
              locales={Constants.localesForTranslation}
              values={this.upsellingCategory.localizedDescriptions}
              isRequired
              className="form-control"
              placeholder={I18n.tr('components.menu.edit_upselling_category.description_placeholder')}
              onChange={this.onDescriptionChange}
              max={this.upsellingCategory.DESCRIPTION_MAX_LENGTH}
            />
          </div>
          <div className="form_error col-xs-6 col-xs-offset-4">
            {this.state.validationErrors.description}
          </div>
        </div>

        <div className="row">

          <div className="col-xs-6 text-left">
            {/* {this.props.upsellingCategory !== null && // only on edit mode
              <button
              type="submit"
              className="btn btn-danger"
              onClick={this.onDelete}
              >
              {I18n.tr('components.menu.edit_upselling_category.delete')}
              </button>
            } */}
          </div>

          <div className="col-xs-6 text-left">
            <button
              type="submit"
              onClick={this.onValidate}
              className="btn btn-primary"
            >
              {I18n.tr('components.menu.edit_upselling_category.submit')}
            </button>
          </div>

        </div>
      </form>
    );
  }

  render() {
    return (
      <Modal
        bsSize="large"
        show={this.props.show}
        onHide={this.onHide}
      >
        <Modal.Header>

          <button
            type="button"
            className="close close-white"
            onClick={this.onClose}
          >
            <span aria-hidden="true">×</span>
          </button>

          <Modal.Title>
            {this.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.renderBody()}
        </Modal.Body>
      </Modal>
    );
  }
}
